import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const SoftwareDevelopmentJobs = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Software Development Jobs in Delhi | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest Software Development Jobs in Delhi NCR. Explore openings for Java, Python, React, and Full Stack Developers. Apply today on JobsInDelhiNCR."
        />
        <meta
          name="keywords"
          content="software development jobs in Delhi, software engineer jobs in Delhi, software developer jobs Delhi NCR, IT jobs in Delhi, full stack developer jobs Delhi, java developer jobs Delhi, python developer jobs Delhi, c++ developer jobs Delhi, fresher software jobs Delhi, software company jobs Delhi NCR"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/softwaredevelopment-jobs-in-Delhi"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Software Development Jobs in Delhi – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Searching for the latest <strong>Software Development Jobs in Delhi NCR</strong>? Whether you’re skilled in Java, Python, C++, or web technologies, explore verified job opportunities from top IT companies and startups hiring software developers in Delhi NCR.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Software Developers in Delhi
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Accenture</li>
          <li>HCL Technologies</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>TCS</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Software Development Roles in Delhi NCR
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Engineer Jobs in Delhi</li>
          <li>Full Stack Developer Jobs in Delhi</li>
          <li>Backend Developer Jobs in Delhi</li>
          <li>Frontend Developer Jobs in Delhi</li>
          <li>Java Developer Jobs in Delhi</li>
          <li>Python Developer Jobs in Delhi</li>
          <li>C++ Developer Jobs in Delhi</li>
          <li>React Developer Jobs in Delhi</li>
          <li>Angular Developer Jobs in Delhi</li>
          <li>Software Tester Jobs in Delhi</li>
        </ul>

        <p className="text-gray-600">
          Begin your software career journey with <strong>jobsindelhincr.in</strong> — your reliable job portal to find verified <strong>Software Development Jobs in Delhi NCR</strong>. Apply directly without registration and connect with top employers across the region.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default SoftwareDevelopmentJobs;
